import { inr, num } from "@/lib/api";

const Meta = ({ label, value }) => value ? (
  <span className="inline-flex items-center gap-1 text-xs">
    <span className="text-slate-400">{label}</span>
    <span className="text-slate-700 font-medium">{value}</span>
  </span>
) : null;

const Stat = ({ label, value, tid }) => (
  <div className="min-w-[86px]">
    <div className="text-[9px] uppercase tracking-widest text-slate-400">{label}</div>
    <div className="text-sm font-semibold tabular-nums text-slate-800" data-testid={tid}>{value}</div>
  </div>
);

export function ProductReadOnlyCards({ items = [], showPricing = true, testPrefix = "ro-item", note, label = "Products", compact = false }) {
  return (
    <div className="space-y-2">
      {label && (
        <p className="text-xs uppercase tracking-widest text-slate-500 font-semibold">
          {label} {note && <span className="normal-case font-normal text-slate-400">({note})</span>}
        </p>
      )}
      {items.map((it, i) => {
        const amt = (+it.quantity || 0) * (+it.unit_price || 0);
        return (
          <div key={i} className={`border border-slate-200 rounded-lg ${compact ? "p-3" : "p-4"} bg-white hover:border-slate-300 transition-colors duration-150`} data-testid={`${testPrefix}-${i}`}>
            <div className="flex items-start justify-between gap-4">
              <div className="min-w-0">
                <div className="flex items-center gap-2 flex-wrap">
                  {it.product_code && <span className="text-[10px] font-mono font-bold bg-[#13264D] text-white rounded px-1.5 py-0.5">{it.product_code}</span>}
                  <span className="font-semibold text-slate-800 text-sm">{it.description || "-"}</span>
                </div>
                <div className="flex flex-wrap gap-x-4 gap-y-1 mt-1.5">
                  <Meta label="Size" value={it.size} />
                  <Meta label="Color" value={it.color} />
                  <Meta label="Cut Length" value={it.cut_length} />
                  <Meta label="Notes" value={it.tc_size} />
                </div>
              </div>
              {showPricing && (
                <div className="text-right flex-none">
                  <div className="text-[9px] uppercase tracking-widest text-slate-400">Amount</div>
                  <div className="font-display font-bold text-slate-900 tabular-nums text-lg leading-tight">{inr(amt)}</div>
                </div>
              )}
            </div>
            <div className="flex flex-wrap gap-x-6 gap-y-2 mt-3 pt-3 border-t border-dashed border-slate-200">
              <Stat label="Quantity" value={`${num(it.quantity)} ${it.unit || ""}`} tid={`${testPrefix}-${i}-qty`} />
              {showPricing && <Stat label={`Price / ${it.unit || "Unit"}`} value={inr(+it.unit_price || 0)} tid={`${testPrefix}-${i}-price`} />}
              {showPricing && <Stat label="GST" value={`${it.gst ?? 0}%`} />}
            </div>
          </div>
        );
      })}
      {items.length === 0 && (
        <div className="text-center text-sm text-slate-500 border border-dashed border-slate-200 rounded-lg py-8" data-testid={`${testPrefix}-empty`}>
          No products on this record.
        </div>
      )}
    </div>
  );
}
